@if (!sideNavMode) {
  <button mat-button [matMenuTriggerFor]="menu" aria-label="Toggle profile menu">
    <mat-icon>account_circle</mat-icon>
    {{loggedUser.username}}
  </button>
  <mat-menu #menu="matMenu">
    @if (!loggedCompetitor) {
      <button mat-menu-item (click)="openAddCompetitorCardDialogDialog()">
        <mat-icon>description</mat-icon>
        {{'Create competitor card' | translate}}
      </button>
    } @else {
      <button mat-menu-item (click)="openEditCompetitorCardDialogDialog()">
        <mat-icon>description</mat-icon>
        {{ loggedCompetitor.firstName + ' ' + loggedCompetitor.lastName }}
      </button>
    }
    @if (!this.competitorIsAlreadyInCrew()) {
      <button mat-menu-item [disabled]="competitorCardIsNotCreated()" (click)="openAddCrewCardDialog()">
        <mat-icon>commute</mat-icon>
        {{'Create crew' | translate}}
      </button>
    } @else {
      <button mat-menu-item [disabled]="competitorCardIsNotCreated()" [matMenuTriggerFor]="submenu">
        <mat-icon>commute</mat-icon>
        {{'My crews' | translate}}
        <mat-menu #submenu>
          @for (crew of crews; track crew.number) {
            <button mat-menu-item (click)="openCrewDetailDialog(crew)">
              <mat-icon>commute</mat-icon>
              {{crew.number}}
            </button>
          }
          <button mat-menu-item (click)="openAddCrewCardDialog()">
            <mat-icon>commute</mat-icon>
            {{'Create crew' | translate}}
          </button>
        </mat-menu>
      </button>
    }
    <button mat-menu-item (click)="onLogout()">
      <mat-icon>exit_to_app</mat-icon>
      {{'Logout' | translate}}
    </button>
  </mat-menu>
} @else {
  <mat-expansion-panel [class.mat-elevation-z0]="true">
    <mat-expansion-panel-header>
      <div class="list-item">
        <mat-icon>account_circle</mat-icon>
        {{loggedUser.username}}
      </div>
    </mat-expansion-panel-header>
    @if (!loggedCompetitor) {
      <a mat-list-item (click)="openAddCompetitorCardDialogDialog()">
        <div class="list-item normal">
          <mat-icon>description</mat-icon>
          {{'Create competitor card' | translate}}
        </div>
      </a>
    } @else {
      <a mat-list-item (click)="openEditCompetitorCardDialogDialog()">
        <div class="list-item normal">
          <mat-icon>description</mat-icon>
          {{ loggedCompetitor.firstName + ' ' + loggedCompetitor.lastName }}
        </div>
      </a>
    }
    @if (!this.competitorIsAlreadyInCrew()) {
      <a mat-list-item [disabled]="competitorCardIsNotCreated()" (click)="openAddCrewCardDialog()">
        <div class="list-item normal">
          <mat-icon>commute</mat-icon>
          {{'Create crew' | translate}}
        </div>
      </a>
    } @else {
      <mat-expansion-panel [disabled]="competitorCardIsNotCreated()" [class.mat-elevation-z0]="true">
        <mat-expansion-panel-header>
          <div class="list-item">
            <mat-icon>commute</mat-icon>
            {{'My crews' | translate}}
          </div>
        </mat-expansion-panel-header>
        @for (crew of crews; track crew.number) {
          <a mat-list-item (click)="openCrewDetailDialog(crew)">
            <div class="list-item normal">
              <mat-icon>commute</mat-icon>
              {{crew.number}}
            </div>
          </a>
        }
        <a mat-list-item (click)="openAddCrewCardDialog()">
          <div class="list-item normal">
            <mat-icon>commute</mat-icon>
            {{'Create crew' | translate}}
          </div>
        </a>
      </mat-expansion-panel>
    }
    <a mat-list-item (click)="onLogout()">
      <div class="list-item normal">
        <mat-icon>exit_to_app</mat-icon>
        {{'Logout' | translate}}
      </div>
    </a>
  </mat-expansion-panel>
}

